import { motion } from "framer-motion";
import { Reveal } from "./Brand";
import { TipForm } from "./TipForm";
import { AUTHOR } from "../lib/site";

const HEADSHOT = "/chris.jpg";

export const Story = () => (
  <section id="story" data-testid="story-section" className="relative py-28 sm:py-40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
      <motion.div className="lg:col-span-5 relative" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}>
        <div className="relative aspect-[4/5] overflow-hidden rounded-t-[999px] rounded-b-3xl">
          <img data-testid="author-headshot" src={HEADSHOT} alt={`Portrait of ${AUTHOR.name}`} className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#121016]/70 via-transparent to-transparent" />
        </div>
        <span className="absolute -bottom-6 -right-2 sm:-right-6 font-mono-d text-[11px] tracking-[0.3em] uppercase bg-[#e3ba73] text-[#121016] px-4 py-2 rounded-full">{AUTHOR.name}</span>
      </motion.div>
      <div className="lg:col-span-7">
        <Reveal><p className="overline mb-6">The author & the book</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            A candid life, written <em className="text-[#e3ba73]">from the inside.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-base sm:text-lg leading-relaxed text-[#c4bbb0] max-w-2xl">{AUTHOR.blurb}</p>
        </Reveal>
        <Reveal delay={0.3}>
          <blockquote className="mt-12 border-l-2 border-[#e3ba73] pl-6 font-serif-d italic text-2xl sm:text-3xl text-[#f4ede2]/95 max-w-xl">
            “…the extraordinary gift of an ordinary life.”
            <footer className="mt-3 not-italic font-mono-d text-[11px] tracking-[0.3em] uppercase text-[#c4bbb0]">— {AUTHOR.name}</footer>
          </blockquote>
        </Reveal>
      </div>
    </div>
  </section>
);

export const TipSection = () => (
  <section id="tip" data-testid="tip-section" className="relative py-28 sm:py-36 bg-[#16121b] border-y border-[#e3ba73]/10 overflow-hidden">
    <div className="absolute bottom-[-30%] left-[-10%] w-[600px] h-[600px] rounded-full bg-[#e3ba73]/10 blur-[140px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5 lg:sticky lg:top-28 self-start">
        <Reveal><p className="overline mb-6">Support my writing</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Keep the pages <em className="gold-foil">turning.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 text-base sm:text-lg text-[#c4bbb0] leading-relaxed">
            No account needed. Leave a one-time tip at any amount, or become a monthly supporter — every dollar goes directly toward my time to write honestly about mental health, faith and recovery.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <ul className="mt-10 space-y-4 text-sm text-[#c4bbb0]">
            {["One-time or monthly, processed by Square", "Apple Pay, Google Pay & cards on Square's page", "Your note lands on my reader wall — if you want it to"].map((t, i) => (
              <li key={t} className="flex gap-4 items-baseline">
                <span className="font-mono-d text-[#e3ba73] text-xs">0{i + 1}</span>{t}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal delay={0.15}><TipForm /></Reveal>
      </div>
    </div>
  </section>
);
